<div class="dropdown-menu" [style.transform]="translate">
    @if (customContentLocation === "TOP") {
        <ng-container *ngTemplateOutlet="customContent; context: customContentContext"></ng-container>
    }

    @for (item of menu; track item; let i = $index) {
        <div>
            @if (item.type === "heading") {
                <h6 class="dropdown-header" [innerHtml]="item.text"></h6>
            }
            @if (item.type === "link") {
                <a class="dropdown-item" [routerLink]="item.link">
                    <span [ngStyle]="{ 'padding-left': item.indent + 'rem' }"></span>
                    @if (item.icon) {
                        <kui-icon class="mr-2" [name]="item.icon"></kui-icon>
                    }
                    <span [innerHtml]="item.text"></span>
                </a>
            }
            @if (item.type === "action") {
                <button class="dropdown-item" (click)="onAction.emit({ item: item, event: $event })">
                    <span [ngStyle]="{ 'padding-left': item.indent + 'rem' }"></span>
                    @if (item.icon) {
                        <kui-icon class="mr-2" [name]="item.icon"></kui-icon>
                    }
                    <span [innerHtml]="item.text"></span>
                </button>
            }
            @if (item.type === "expandable") {
                <button class="dropdown-item" (click)="toggleExpandableDropdown(item)">
                    @if (item.icon) {
                        <kui-icon class="mr-2" [name]="item.icon"></kui-icon>
                    }
                    <span [innerHtml]="item.text"></span>
                </button>
                @for (child of item.children; track child) {
                    @if (item.isExpanded) {
                        <button class="dropdown-item" (click)="onAction.emit({ item: child, event: $event })">
                            <span [ngStyle]="{ 'padding-left': child.indent + 'rem' }"></span>
                            @if (item.icon) {
                                <kui-icon class="mr-2" [name]="child.icon"></kui-icon>
                            }
                            <span [innerHtml]="child.text"></span>
                        </button>
                    }
                }
            }
            @if (item.type === "radio") {
                <button class="dropdown-item d-flex" (click)="onAction.emit({ item: item, event: $event })">
                    <span [ngStyle]="{ 'padding-left': item.indent + 'rem' }"></span>
                    <span class="pr-3" [innerHtml]="item.text"></span>
                    @if (item.checked) {
                        <kui-icon class="pl-2 ml-auto" [name]="item.icon || 'check'"></kui-icon>
                    }
                </button>
            }
            @if (item.type === "checkbox" || item.type === "toggle") {
                <div class="dropdown-item" (click)="dispatchToggleAction(item, $event)">
                    <div class="position-relative d-flex align-items-center">
                        <label class="mb-0 pointer pr-4">
                            <span [ngStyle]="{ 'padding-left': item.indent + 'rem' }"></span>
                            @if (item.icon) {
                                <kui-icon class="mr-2" [name]="item.icon"></kui-icon>
                            }
                            <span [innerHtml]="item.text"></span>
                        </label>
                        @if (item.type === "checkbox") {
                            <input kui-checkbox [id]="'dropdownCheckbox' + i" [checked]="item.checked" class="right pointer" />
                        }
                        @if (item.type === "toggle") {
                            <kui-toggle [checked]="item.checked" size="sm" class="pl-2 ml-auto"></kui-toggle>
                        }
                    </div>
                </div>
            }
            @if (item.type === "divider") {
                <div class="dropdown-divider"></div>
            }
        </div>
    }

    @if (customContentLocation === "BOTTOM") {
        <ng-container *ngTemplateOutlet="customContent; context: customContentContext"></ng-container>
    }
</div>
